var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "contact-card",
      class: {
        "is-selected": _vm.isSelected,
        "is-unread": _vm.contact.unread,
        "has-trigger-success": _vm.broadcastTriggerSuccess,
        "has-trigger-waiting": _vm.broadcastTriggerWaiting,
      },
      on: { click: _vm.handleClick },
    },
    [
      _vm.broadcastTriggerSuccess
        ? _c(
            "div",
            {
              staticClass: "trigger-success-badge",
              attrs: {
                title: _vm.$t("chat.kanbanContactList.broadcastTriggerSuccess"),
              },
            },
            [
              _c("i", { staticClass: "material-icons tada-animation" }, [
                _vm._v("celebration"),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.broadcastTriggerWaiting
        ? _c(
            "div",
            {
              staticClass: "trigger-waiting-badge",
              attrs: {
                title: _vm.$t("chat.kanbanContactList.broadcastTriggerWaiting"),
              },
            },
            [
              _c("i", { staticClass: "material-icons hourglass-animation" }, [
                _vm._v("hourglass_empty"),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "contact-card-header" }, [
        _c("div", { staticClass: "contact-avatar" }, [
          _c(
            "div",
            {
              staticClass: "avatar-circle",
              style: {
                backgroundColor: _vm.getAvatarColor(_vm.contact.fullname),
              },
            },
            [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.getAvatarInitials(_vm.contact.fullname)) +
                  "\n            "
              ),
            ]
          ),
          _vm._v(" "),
          _vm.platformIcon
            ? _c(
                "div",
                {
                  staticClass: "platform-badge",
                  attrs: { title: _vm.contact.platform },
                },
                [
                  _vm.isWhatsappPlatform
                    ? _c("WhatsappIcon", {
                        staticClass: "whatsapp-icon",
                        attrs: { color: "#25D366" },
                      })
                    : _c("i", { staticClass: "material-icons" }, [
                        _vm._v(_vm._s(_vm.platformIcon)),
                      ]),
                ],
                1
              )
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "contact-info" }, [
          _c("div", { staticClass: "contact-name" }, [
            _vm._v(
              "\n                " +
                _vm._s(
                  _vm.maskNameIfPhone(
                    _vm.contact.fullname ||
                      _vm.$t("chat.kanbanContactList.unknownUser")
                  )
                ) +
                "\n            "
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "contact-meta" }, [
            _vm.contact.email
              ? _c("span", { staticClass: "meta-item" }, [
                  _vm._v(_vm._s(_vm.maskField("email", _vm.contact.email))),
                ])
              : _vm.contact.phone
              ? _c("span", { staticClass: "meta-item" }, [
                  _vm._v(_vm._s(_vm.maskField("phone", _vm.contact.phone))),
                ])
              : _vm.contact.whatsappNumber
              ? _c("span", { staticClass: "meta-item" }, [
                  _vm._v(
                    _vm._s(
                      _vm.maskField(
                        "whatsappNumber",
                        _vm.contact.whatsappNumber
                      )
                    )
                  ),
                ])
              : _vm._e(),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _vm.lastMessagePreview
        ? _c("div", { staticClass: "contact-last-message" }, [
            _c("span", { staticClass: "message-icon" }, [
              _c("i", { staticClass: "material-icons" }, [
                _vm._v(_vm._s(_vm.lastMessageIcon)),
              ]),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "message-text" }, [
              _vm._v(_vm._s(_vm.lastMessagePreview)),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "contact-card-footer" }, [
        _c("div", { staticClass: "footer-left" }, [
          _vm.contact.unread
            ? _c("span", { staticClass: "badge badge-unread" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("chat.kanbanContactList.unread")) +
                    "\n            "
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.contact.vipCustomer
            ? _c("span", { staticClass: "badge badge-vip" }, [
                _c("i", { staticClass: "material-icons" }, [_vm._v("star")]),
                _vm._v("\n                VIP\n            "),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.answerStatusBadge
            ? _c(
                "span",
                { staticClass: "badge", class: _vm.answerStatusBadge.class },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.answerStatusBadge.text) +
                      "\n            "
                  ),
                ]
              )
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "footer-right" }, [
          _vm.formattedTime
            ? _c(
                "span",
                {
                  staticClass: "time-badge",
                  attrs: { title: _vm.fullTimeString },
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.formattedTime) +
                      "\n            "
                  ),
                ]
              )
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _vm.visibleTags.length > 0
        ? _c(
            "div",
            { staticClass: "contact-tags" },
            [
              _vm._l(_vm.visibleTags, function (tag) {
                return _c(
                  "span",
                  {
                    key: tag._id,
                    staticClass: "tag-badge",
                    style: { backgroundColor: tag.color || "#6b7280" },
                  },
                  [_vm._v("\n            " + _vm._s(tag.name) + "\n        ")]
                )
              }),
              _vm._v(" "),
              _vm.remainingTagsCount > 0
                ? _c("span", { staticClass: "tag-badge tag-more" }, [
                    _vm._v(
                      "\n            +" +
                        _vm._s(_vm.remainingTagsCount) +
                        "\n        "
                    ),
                  ])
                : _vm._e(),
            ],
            2
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }